import React from 'react'
import { Link } from 'react-router-dom'
import MoreButton from '../components/MoreButton'

const EmptyState = () => (
  <div className="o-width-limiter text-center mt-48 mb-96 lg:mt-80 lg:mb-128 lg:pb-64">
    <p className="type-large text-grey-lighter leading-default mb-32">
      This category is as empty as my fridge after a cheat day.
    </p>
    <MoreButton use={Link} to="/nutrition-explained/">
      Other stories
    </MoreButton>
  </div>
)

export default EmptyState
